<template>
  <div style="z-index: -1">
    <div v-bind:class="{ menu: hasMenu, 'no-menu': !hasMenu }" :style="isShareSession ? 'margin-left:0px;width:100% !important':'' ">
      <div class="row no-drag"> 
        <div class="col-sm-4 col-md-4 mr-auto ml-3 my-2 flex-nowrap row" 
          :style="isShareSession ? 'padding-left:0px':'' " >
          <div
            class="mx-2 cursor-pointer no-drag highlight-btn font-weight-bold"
            @click="showOption = !showOption"
            v-if="!isShareSession && $version !== 2"
          >
            <span class="d-inline" >{{ widget_name }}</span>
            <font-awesome-icon class="d-inline" icon="caret-down" />
          </div>
          <div
            class="mx-2 cursor-pointer no-drag highlight-btn font-weight-bold"
            v-else-if="$version !== 2"
          >
            <span class="d-inline" >{{ temp_widget_name }}</span>
          </div>
          <div class="d-inline " v-if="!expireAccount">
            <AirbnbDatePicker
                module="dashboard"
                ref="datePicker"
              ></AirbnbDatePicker>
          </div>
        </div>

        <div v-if="!isShareSession" class="col-lg-7 col-md-7 ml-auto text-right my-2 mr-3 nowrp" >
          <router-link
            style="text-decoration: none !important"
            to="/subscription"
            class="headerMenu text-decoration-none cursor-pointer"
            v-if="isHowukuDomain && freeplan && !trailEnded"
          >
            <div class="d-inline mx-1">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2 text-warning"
                icon="star"
              /><span  class="d-none d-lg-inline d-xl-inline font-weight-bold">{{
                t('Upgrade')
              }}</span>
            </div>
          </router-link>
          <span
            style="text-decoration: none !important"
            @click="extendTrialPopUp()"
            class="headerMenu text-decoration-none cursor-pointer"
            v-else-if="isHowukuDomain && isAdminRole && trailEnded"
          >
            <div class="d-inline mx-1">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2 text-warning"
                icon="star"
              />
              <span class="d-none d-lg-inline d-xl-inline font-weight-bold">{{
                t('Extend Trial')
              }}</span>
            </div>
          </span>
          <!--
          <span
            v-show="isLocalhost || $session.get('company_id') === 3108"
            class="
              headerMenu
              text-decoration-none
              cursor-pointer
              mr-2
              font-weight-bold
            "
            @click="openRecommendation"
          >
            <div class="highlight-btn">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2"
                icon="lightbulb"
              />Recommendations
            </div>
          </span>
          -->
          <span
            v-if="isHowukuDomain"
            class="
              headerMenu
              text-decoration-none
              cursor-pointer
              mr-2
              font-weight-bold
            "
            @click="openMessageSupport()"
          >
          <!-- openMessageSupport() -->
            <div class="highlight-btn">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2 "
                icon="paper-plane"
              />Message Support
            </div>
          </span>
          <span
            class="headerMenu text-decoration-none cursor-pointer mr-2 font-weight-bold"
            @click="openLink('https://howuku.freshdesk.com/support/solutions/150000210866')"
            v-if="isHowukuDomain && $version !== 2"
          ><!-- openLink('https://help.howuku.com/')-->
            <div class="highlight-btn">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2"
                icon="book"
              /><span class="d-none d-lg-inline d-xl-inline"
                >{{ t('Help Center') }}
              </span>
            </div>
          </span>
          <span
            class="headerMenu text-decoration-none cursor-pointer mr-2 font-weight-bold"
            @click="openLink('https://howuku.freshdesk.com/support/solutions/150000191514')"
            v-if="isHowukuDomain && $version === 2"
          ><!-- openLink('https://help.howuku.com/')-->
            <div class="highlight-btn">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2"
                icon="book"
              /><span class="d-none d-lg-inline d-xl-inline"
                >{{ t('Help Center') }}
              </span>
            </div>
          </span>
          <span
            class="
              headerMenu
              text-decoration-none
              cursor-pointer
              mr-2
              font-weight-bold
            "
            @click="showHelpOption = !showHelpOption"
            v-if="isHowukuDomain"
          >
            <div class="highlight-btn">
              <font-awesome-icon
                class="fa-md cursor-pointer profile-pic mr-2"
                icon="inbox"
              /><span class="d-none d-lg-inline d-xl-inline"
                >{{ t('Resources') }}
                <font-awesome-icon class="d-inline" icon="caret-down" />
              </span>
            </div>
          </span>
          <span
            class="
              headerMenu
              text-decoration-none
              cursor-pointer
              mr-2
              font-weight-bold
            "
            @click="showSettingOption = !showSettingOption"
          >
            <div class="d-inline-block">
              <span class="font-weight-normal">
                <img
                  class="
                    d-inline
                    mr-2
                    profile-picture
                    perfect-circle
                    my-auto
                    mx-auto
                  "
                  width="32"
                  height="32"
                  :src="`https://api.mida.so/avatar/${$session.get('email')}?v=6&name=${$session.get('name')}`"
                  @error="handleImageError"
                />
              </span>
            </div>
          </span>
        </div>
        <transition name="fade">
          <div
            class="dropdown-list dropdown-content-project dropdown-menu-right"
            v-on-clickaway="hideContent"
            v-if="showHelpOption"
          >
            <!-- <span @click="openLink('https://www.facebook.com/groups/conversionrateoptimizationcro')">{{
              t('Join Community')
            }}</span> -->
            <span v-if="$isOptimize" @click="openLink('https://trello.com/b/J7W1VX1Q/howuku-optimize-public-product-roadmap')">{{
              t('Public Roadmap')
            }}</span>
            <span v-else @click="openLink('https://trello.com/b/WNHWeI6N/howuku-public-product-roadmap')">{{
              t('Public Roadmap')
            }}</span>

            <!-- <span
              @click="
                openLink('https://howuku.freshdesk.com/support/tickets/new')
              "
            >
              {{ t('Submit Idea') }}
            </span> -->

            <span
              v-show="isHowukuDomain && showEarn"
              @click="$router.push({ path: '/affiliate-program' })"
              v-if="(!$isOptimize && $isHowuku && !hasCustomDomain && !excludedPlan.includes($session.get('paid_plan'))) || $session.get('company_id') === 1"
            >
              {{ t('Refer & Earn $100') }}
            </span>
            <!--               openLink(
                'https://www.facebook.com/groups/conversionrateoptimizationcro'
              ) -->
            <!-- <span
              @click="
                openLink('https://1drv.ms/w/s!ApBcNuAQ1SIahxjw6i7N0PGk9zRw')
              "
            >
              {{ t('User Guide') }}
            </span> -->
            
            <!-- <span
              @click="
                openLink(
                  'https://loom.com/share/folder/05fd66d929064e528d991e7838e3d5da'
                )
              "
            >
              {{ t('Tutorial Video') }}
            </span>
            <hr /> -->
            <!-- <span @click="openLink('https://stats.howuku.com/')">{{
              t('Service Uptime')
            }}</span> -->
            <!-- <span
              @click="
                openLink('https://headwayapp.co/howuku-product-changelog')
              "
              >{{ t("What's New?") }}</span
            > -->
          </div>
        </transition>
        <transition name="fade">
          <div
            class="dropdown-list dropdown-content-setting dropdown-menu-right"
            v-on-clickaway="hideContent"
            v-if="showSettingOption"
          >
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/profile"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="user-circle" />{{
                t('My Profile')
              }}
            </router-link>
            <template v-if="isAdminRole">
              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/company"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="building" />{{
                  t('Company')
                }}
              </router-link>
              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/team"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="users" />{{
                  t('Team')
                }}
              </router-link>
            </template>
            <template v-if="isAdminRole && ($session.get('paid_plan') === 104 || $session.get('company_id') === 1)">
              <span
                @click="toServicePortal"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="star" />{{
                  t('Service Portal')
                }}
              </span>
            </template>

            <hr />

            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/website"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="shapes" />{{
                t('Website')
              }}
            </router-link>
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/block-ip"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="ban" />{{
                t('Block IP')
              }}
            </router-link>
            <template v-if="isAdminRole">
              <hr />

              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/subscription"
              >
                <font-awesome-icon
                  class="mr-2 text-muted"
                  icon="money-bill"
                />{{ t('Subscription') }}
              </router-link>
              <router-link
                @click="showSettingOption = false"
                tag="span"
                to="/payment"
              >
                <font-awesome-icon class="mr-2 text-muted" icon="receipt" />{{
                  t('Payment')
                }}
              </router-link>
            </template>
            <hr />
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/affiliate-program"
              v-if="(!$isOptimize && $isHowuku && !hasCustomDomain && !excludedPlan.includes($session.get('paid_plan')))"
            >
              <font-awesome-icon class="mr-2 text-muted" icon="dollar-sign" />{{
                t('Refer & Earn')
              }}
            </router-link>
            <hr v-if="($isHowuku && !hasCustomDomain && !excludedPlan.includes($session.get('paid_plan')))" />
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/logout"
            >
              <font-awesome-icon
                class="mr-2 text-muted"
                icon="sign-out-alt"
              />{{ t('Logout') }}
            </router-link>
          </div>
        </transition>
        <transition name="fade">
          <div
            class="
              dropdown-list dropdown-content-widget dropdown-menu-left
              scroll-list
            "
            v-on-clickaway="hideContent"
            v-if="showOption"
            style="max-height: 387px; overflow: hidden; overflow-y: scroll"
          >
            <span id="searchproject" class="p-0">
              <input
                class="search search-icon"
                @keyup="filterName($event.target.value)"
                :placeholder="t('Search projects')"
              />
            </span>

            <div
              v-for="item in projects"
              v-bind:key="item.widget_id"
              v-show="item.status === 1 || $session.get('company_id') === 1334"
            >
              <div
                v-if="
                  filterText === '' ||
                  item.widget_name
                    .toLowerCase()
                    .includes(filterText.toLowerCase())
                "
              >
                <span @click="setProject(item.widget_id, item.widget_name)">{{
                  item.widget_name
                }}</span>
              </div>
            </div>
            <router-link
              @click="showSettingOption = false"
              tag="span"
              to="/website"
              id="viewproject"
            >
              {{ t('View All Projects') }}
            </router-link>
          </div>
        </transition>
      </div>
    </div>
    <modal
      name="modal-recommendation"
      style="z-index: 10000"
      class="to-right full-modal"
      width="500px"
      height="100%"
      :adaptive="true"
    >
      <SmartRecommendation></SmartRecommendation>
    </modal>
  </div>
</template>

<script>
import { store } from '@/store'
import { mixin as clickaway } from 'vue-clickaway'
import SmartRecommendation from '@/components/SmartRecommendation.vue'
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')
var axios = require('axios')

/* eslint-disable */
export default {
  mixins: [clickaway],
  store,
  props: ['hasMenu'],
  components: {
    AirbnbDatePicker,
    SmartRecommendation,
  },
  data: function () {
    return {
      filterText: '',
      isLocalhost: false,
      isHowuku: window.location.href.includes('howuku.com'),
      isAdmin:
        this.$session.get('role') === 0 || this.$session.get('role') === 1,
      projects: [],
      widget_name: '',
      showOption: false,
      showHelpOption: false,
      showSettingOption: false,
      isHowukuDomain: false,
      isAdminRole: false,
      showEarn: true,
      expireAccount:false,
      freeplan:false,
      isShareSession:false,
      secretPosition:17,
      temp_widget_name:'',
      trailEnded:false,
      showRecommendation:false,
      isHowuku: true,
      hasCustomDomain: false,
      excludedPlan: [104, 801, 802, 803],
      isNewWLClient: false
    }
  },
  watch:{
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        if (this.$route.query.startDate || this.$route.query.endDate)  {
          this.$refs.datePicker.setCustomDisplayDate(this.$route.query.startDate, this.$route.query.endDate)
        }
      },
      deep:true,
    },
    '$store.getters.widget_id' : {
      handler:function(){
        if(!this.isShareSession){
          this.checkForRecommendation()
        }
      },
      deep: true,
    }
  },
  async mounted() {
    this.$http
      .get(process.env.API_ENDPOINT + '/getCompany')
      .then((response) => {
        let companyInfo = response.data[0]
        if (companyInfo.custom_domain !== '') {
          this.hasCustomDomain = true
        }
        if (companyInfo.whitelabel_ref_id) {
          this.isNewWLClient = true
        }
      })

    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')

    if(this.$session.get('is_pageview') === 1) this.showEarn = false;

    //Inject Headway app script
    let headway = document.getElementById('headway-script')
    if (headway) return //Script already appended

    //Create promise which resolves on script load
    let promise = new Promise((resolve, reject) => {
      let script = document.createElement('script')
      script.src = '//cdn.headwayapp.co/widget.js'
      script.id = 'headway-script'
      script.setAttribute('async', true)
      document.head.appendChild(script)
      script.onload = resolve //Resolve when loaded
      script.onerror = reject
    })
    await promise //Await for the script to be resolved
    //Init the widget now that the script has loaded
    // eslint-disable-next-line no-undef
    Headway.init({
      selector: '.header',
      account: 'x824WJ',
    })

    let limit = 0
    let check = setInterval(() => {
      if (((this.widget_name && this.widget_name !== '') || limit > 10)) {
        clearInterval(check)
      } else {
        (!this.$route.params.encryptedParam) ? this.init() : ''
      }
      limit++
    }, 1000)
  },
  created() {
    this.isHowukuDomain =
      window.location.href.includes('.howuku.com') ||
      window.location.href.includes('//localhost:')
  },
  beforeMount() {
    if(this.$route.params.encryptedParam) {
      this.temp_widget_name = window.TEMP_WIDGET_NAME
      this.isShareSession = true
        let enc = this.$route.params.encryptedParam
        enc = enc.slice(0, this.secretPosition) + enc.slice(this.secretPosition + 1)
        let jsonString = window.atob(enc)

        let json = JSON.parse(jsonString)
        this.temp_widget_name = json.widget_name
    }else{
      this.checkForRecommendation()
    }

    this.isLocalhost = window.location.href.includes('localhost:80')
    this.isAdminRole =
      this.$session.get('role') !== 3 && this.$session.get('role') !== 2

    this.widget_name = ''
    this.checkFor30dayExpire()
    console.log(this.isAdmin)
    console.log('Header before mount')
    this.freeplan = (this.$session.get('paid_plan') === 0 ||this.$session.get('paid_plan') === 4)
    this.trailEnded = (this.$session.get('paid_plan') === 0 )
    this.init()
  },
  methods: {
    openMessageSupport(){
      this.$swal
          .fire({
            html: `
            <div class="box p-2">
              <div>
                <div class="col-md-12 px-4 mx-auto">
                  <div class="row text-left">
                    <div class="mb-3 message-support-header" >
                      <h3><b>Message Support</b></h3>
                    </div>
                    <br>
                    <p><h6 style="margin-bottom:15px">Please leave your information below.</h6><br><h6>Our representative will reach out you shortly with your account email.</h6><p>
                    <br>
                    <input
                      type="text"
                      placeholder="Subject"
                      id="message-support-subject"
                      class="form-control"
                      style="width: 400px; border: 2px solid rgb(228, 232, 235);"
                      autocomplete="off"
                      required
                    />
                    <div class="form-group mt-2">
                      <textarea
                        id="message-support-text"
                        type="textarea"
                        class="form-control custom-textarea"
                        autocomplete="off"
                        placeholder="Write your message here"
                        required
                      /></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `
        ,
          reverseButtons: true,
          customClass: 'swal-container',
          confirmButtonText: 'Send',
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonClass: 'btn btn-first swal-confirm-btn mb-3',
          cancelButtonClass: 'btn btn-muted swal-cancel-btn',
          preConfirm: () => {
            let subject = document.getElementById('message-support-subject').value
            let text = document.getElementById('message-support-text').value
            if (!subject || !text) {
              this.$swal.showValidationMessage(`Please fill in subject and message`)
            }
            return { subject: subject, text: text }
          }
          })
          .then((result) => {
            console.log(result.value,result.value.subject.length,result.value.text.length)
            if(result.value) {
              
              if(result.value.subject.length && result.value.text.length) {
                this.$http
                  .post(process.env.API_ENDPOINT + '/getUsers')
                  .then((response) => {
                    let data = response.data[0]
                    this.$http.post(process.env.API_ENDPOINT + '/message/support', {
                        from: data.email,
                        to: 'customer.support@howuku.com',
                        subject: result.value.subject,
                        text: result.value.text
                      })
                      .then((res) => {
                        this.$swal.fire({
                          type: "success",
                          title:'Submitted',
                          text: 'Your message has been sent!'
                        })
                      })

                  })
                console.log(document.getElementById('message-support-text').value)
              }
            }
          })
    },
    filterName(val) {
      this.filterText = val
    },
    openRecommendation() {
      this.$modal.show('modal-recommendation')
    },
    setTab(module_name, n) {
      this.$store.commit('setTab', {
        module: module_name,
        data: n,
      })
    },
    logout: function () {
      this.$router.push({ path: '/logout' })
    },
    setProject(id, name) {
      console.log('this run')
      this.filterText = ''
      localStorage.setItem('widget_name', name)
      localStorage.setItem('widget_id', id)
      this.showOption = false
      this.widget_name = name
      this.$session.set('widget_name', name)
      this.$session.set('widget_id', id)
      this.$http.defaults.headers.widgetid = id
      this.$store.commit('setWidgetId', id)

      setTimeout(() => {
        let dp = this.$store.getters.datepicker
        for (let i in dp) {
          let original = dp[i].startDate
          let originalEnd = dp[i].endDate

          this.$store.commit('setDatepicker', {
            module: i,
            name: 'startDate',
            data: 1,
          })

          this.$store.commit('setDatepicker', {
            module: i,
            name: 'startDate',
            data: original,
          })

          this.$store.commit('setDatepicker', {
            module: i,
            name: 'endDate',
            data: 1,
          })

          this.$store.commit('setDatepicker', {
            module: i,
            name: 'endDate',
            data: originalEnd,
          })
        }
      }, 100);
      this.$auditlog({ module: 'usage', action: 'change_project' })  
            
      try{
        howuku.track('usage', { feature: 'change_project' })
      }catch(e){}

      try{
        _cio.track('usage', { feature: 'change_project', created_at: Math.round(new Date().getTime() / 1000) })
      }catch(e){}         
    },
    triggerBadge() {
      setTimeout(() => {
        document.getElementById('HW_badge').click()
      }, 10)
    },
    hideContent() {
      this.showOption = false
      this.showHelpOption = false
      this.showSettingOption = false
      this.filterText = ''
    },
    openLink(url) {
      window.open(url, '_blank')
    },
    init() {
      console.log('getWidgetsNoCache - header')
      this.$http
        .post(process.env.API_ENDPOINT + '/getWidgetsNoCache', {
          user_id: this.$session.get('user_id'),
        })
        .then((response) => {
          this.projects = response.data
          if (
            localStorage.getItem('widget_name') &&
            localStorage.getItem('widget_id')
          ) {
            this.setProject(
              localStorage.getItem('widget_id'),
              localStorage.getItem('widget_name')
            )
          } else if (this.$session.exists()) {
            for (let i = 0; i < this.projects.length; i++) {
              if (Number(this.projects[i].status) === 1) {
                let id = this.projects[i].widget_id
                this.widget_name = this.projects[i].widget_name
                this.setProject(id, this.widget_name)
                break
              }
            }
          }
        })
    },
    checkFor30dayExpire(){
      if(!this.$route.params.encryptedParam){
        
        this.$http.get(process.env.API_ENDPOINT + '/checkFor30DayExpire').then((response) => {
          let data = response.data
          if(data.prohibit === 1){
            this.expireAccount = true
          }
        })
      }
    },
    extendTrialPopUp(){
      this.$swal.fire({
        showCancelButton: true,
        html: '<img class="extend-gift" src="https://thumbs2.imgbox.com/e5/a7/YPTzu5ix_t.png" alt="image host"/> <h2 class="extend-title">Unbox 100 days of howuku trial for free.</h2> <br> <p class="mx-3 extend-text">Your 15-day free trial ended recently, but we would like to give you an extended run. Help us spread the word about Howuku and we&#8217;ll extend your trial up to 100 days.</p>',
        customClass: 'swal-container-2',
        confirmButtonText: 'Extend Trial by 100 Days',
        cancelButtonText: 'No, i dont&#8217;t want an extended trial',
        cancelButtonClass: 'text-decoration-underline cursor-pointer border-none text-muted cancelBtnFont',
        confirmButtonClass: 'btn btn-first mb-1 px-2 w-50 confirmBtnFont',
        closeButtonClass:'closeBtnStyle',
        showCloseButton: true,
        buttonsStyling: false,
      }).then((isConfirmed) =>{
        if (isConfirmed.value) {
          this.$router.push({path: '/extend-trials'})
        }
      })
    },
    checkForRecommendation(){
      this.showRecommendation = false
      this.$http.get(process.env.API_ENDPOINT + '/checkForRecommendation/' + this.$session.get('widget_id')).then((response) => {
          let data = response.data
          console.log(data[0])
          if(data[0] !== null && data[0] !== undefined){
            this.showRecommendation = true
          }
        })
    },
    handleImageError(event) {
      // let curName = this.$session.get('name')
      // let convertedName = curName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "dj").replace(/Đ/g, "DJ");
      let img = event.target;
      let curEmail = this.$session.get('email')
      axios
        .get('https://api.mida.so/avatar/' + curEmail + '?v=6&name=' + 'N', { responseType: 'blob' })
        .then(response => {
          const reader = new FileReader();
          reader.onload = () => {
            img.src = reader.result;
          };
          reader.readAsDataURL(response.data);
        })
        .catch(error => {
          console.log(error)
        })
    },
    toServicePortal() {
      this.showSettingOption = false
      window.open('/service-portal', '_blank');
    }
  },
}
</script>
<style>
.no-menu {
  position: fixed;
  width: -webkit-calc(100% - var(--sidebar-width)); /* menubar-width */
  width: -moz-calc(100% - var(--sidebar-width)); /* menubar-width */
  width: calc(100% - var(--sidebar-width)); /* menubar-width */
  height: 56px;
  /* background: linear-gradient(0deg, #e9ebed 1px, #ffffff 1px); */
  /* background: var(--background-header); */
  background: white;
  z-index: 4;
  margin-left: var(--sidebar-width); /* menubar-width */
  padding-top: 4px;
  padding-left: 20px;
  padding-right: 20px;  
  /* padding-left: calc(calc(100% - 1280px - var(--sidebar-width)) / 2);
  padding-right: calc(calc(100% - 1280px - var(--sidebar-width)) / 2);   */
}

.menu {
  position: fixed;
  width: -webkit-calc(100% - 260px);
  width: -moz-calc(100% - 260px);
  width: calc(100% - 260px);
  height: 56px;
  /* background: linear-gradient(0deg, #e9ebed 1px, #ffffff 1px); */
  /* background: var(--background-header); */
  background: white;
  z-index: 4;
  margin-left: 260px;
}

.bg-second {
  background-color: #eaedf1 !important;
}

.dropdown-content-widget {
  position: absolute;
  background-color: var(--background);
  top: 55px;
  margin-left: 30px;
  max-width: 500px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  text-align: left;
  z-index: 10;
  border: 1px #ccc solid;
}

.dropdown-content-project {
  position: absolute;
  background-color: var(--background);
  top: 55px;
  /* left: 30px !important; */
  right: 77px !important;
  max-width: 220px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 10;
  border: 1px #ccc solid;
}

.dropdown-content-setting {
  position: absolute;
  background-color: var(--background);
  top: 55px;
  /* left: 30px !important; */
  right: 20px !important;
  max-width: 220px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 10;
  border: 1px #ccc solid;
}

.dropdown-menu-left {
  left: 2px;
}

.dropdown-menu-right {
  right: 50px;
}

.dropdown-list > hr {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.dropdown-list span {
  color: var(--color);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: default;
}

.dropdown-list span:hover {
  background-color: rgba(var(--main-color), 0.1);
}

.widget-selector {
  padding: 10px;
  background-color: rgba(var(--main-color), 0.1);
  border-radius: 4px;
  color: rgba(var(--main-color), 0.8);
}

.top-button {
  color: #2c3e50;
  cursor: pointer;
  display: flex;
  line-height: 1;
  width: 40px;
  height: 40px;
  margin-right: 4px;
  outline-style: none;
  outline-width: initial;
  text-decoration: none;
  text-align: right;
  padding: 10px;
  border-radius: 4px;
}

.top-button:hover {
  background-color: #0068cf1e;
  text-decoration: none;
  color: #2167f5;
}

.tabmenu {
  color: #868686;
}

.tabmenu:hover {
  border-bottom: 3px solid rgba(var(--main-color), 0.5);
  padding-bottom: 16px !important;
}

.selectedTab {
  font-weight: bold;
  color: #000000 !important;
  border-bottom: 3px solid rgba(var(--main-color), 0.8);
  padding-bottom: 16px !important;
}

.nowrp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  min-width: 1px;
}

.profile-pic {
  border-radius: 50%;
}

.profile-pic:hover::before {
  border-color: rgb(230, 230, 230);
}

.header {
  display: none;
}

.HW_badge_cont {
  display: inline !important;
}

.HW_frame_cont {
  top: 55px !important;
}

#HW_frame_cont {
  left: calc(100% - 340px) !important;
}

.headerMenu {
  color: #586069;
}
.headerMenu:hover {
  color: rgba(var(--main-color), 1);
}
.scroll-list::-webkit-scrollbar {
  display: none;
  position: sticky;
}
#viewproject {
  background: white;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0px;
  border-top: 0.05px lightgrey solid;
  text-align: center;
}
#viewproject:hover {
  background-color: #e6eaee;
}
#searchproject {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  border-bottom: 1px solid #e8e8e8;
}
#searchproject:hover {
  background-color: none;
}
#searchproject input.search {
  height: 44px;
  border: none !important;
  outline: 0px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: 500;
  width: 100%;
}
#searchproject input.search::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
#searchproject input.search::-moz-placeholder {
  /* Firefox 19+ */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
#searchproject input.search:-ms-input-placeholder {
  /* IE 10+ */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
#searchproject input.search:-moz-placeholder {
  /* Firefox 18- */
  padding-left: 3px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}
.custom-textarea {
  padding: 2px 10px 0px 10px !important;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
  letter-spacing: 0px !important;
  -webkit-box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 6%);
  box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 6%);
  border: 2px solid rgb(228, 232, 235);
  border-radius: 4px;
  overflow: auto;
  resize: none;
  width: 525px !important;
  height: 205px !important;
}
.swal-container {
  width: 600px !important;
  bottom: 70px !important;
}
.swal-confirm-btn {
  margin-left: 380px !important;
}
.swal-cancel-btn {
  margin-right: 0px !important;
}
.swal-container-2{
  width: 900px !important;
  height: 700px !important;
}
.swal-container-2 > .swal2-actions > .swal2-cancel{
  background-color: transparent !important;
  text-decoration: underline !important;
  width: 100%;
  border: none;
}
.confirmBtnFont{
  font-size: 18px !important;
}
.swal-container-2 > .swal2-header > .swal2-close{
  border-radius: 50%;
  background-color: rgba(var(--main-color),.1);
  color:#000000;
  font-size: 30px;
  right:20px;
  top:20px;
}
.message-support-header{
  display:flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
}
@media only screen and (max-width: 1550px) {
  .swal-container-2 > .swal2-header > .swal2-close{
    font-size: 24px;
    right:10px;
    top:10px;
  }
  .swal-container-2{
  width: 750px !important;
  height: 500px !important;
  }
  .swal-container-2 > .swal2-content{
    width: 700px !important;
    height: 400px !important;
  }
  .extend-gift {
    width: 250px !important;
    height: 250px !important;
  }
  .confirmBtnFont{
  font-size: 14px !important;
  }
  .cancelBtnFont{
    font-size: 14px;
  }
  .extend-title{
    font-size: 22px;
  }
  .extend-text{
    font-size: 16px;
  }
  .swal-container-2 > .swal2-actions{
    margin-bottom: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue